import { Button, Col, Form, Input, Row, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getInvoiceQueryRequest, addInvoiceCommentWpRequest, acceptInvoiceQueryWpRequest } from '../../core/invoiceQuery/invoiceQueryActions';

import './style.scss';

const InvoiceQuery = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { invoiceQueryNo } = useParams();
    const { invoiceQuery, invoiceQueryComments, isFetchingInvoiceQuery, isFetching } = useSelector(state => state.invoiceQuery);

    const submitComment = () => {
        const comment = form.getFieldValue('comment');
        const data = {
            invoiceQueryId: invoiceQueryNo,
            comment,
        };
        // 20250819 Ragul FIX THX-252 Added Add Comments method to update in WP
        dispatch(addInvoiceCommentWpRequest(data));
        form.resetFields();
    };

    // 20250819 Ragul FIX THX-252 Added Accept Resolution method to accept invoice query
    const acceptResolution = () => {
        const data = {
            invoiceQueryId: invoiceQueryNo,
            status: 'resolved',
        };
        dispatch(acceptInvoiceQueryWpRequest(data));
    };

    useEffect(() => {
        dispatch(getInvoiceQueryRequest({ invoiceId: invoiceQueryNo }));
    }, []);

    return (
        <Spin spinning={isFetching || isFetchingInvoiceQuery} size="large">
            <div className="invoice-query-container container">
                <h5>Status: {invoiceQuery?.status}</h5>
                <Row>
                    <Col span={12}>
                        <p>Invoice: <strong>{invoiceQuery?.syrinx_invoice_id}</strong></p>
                        <p>Reason: <strong>{invoiceQuery?.reason}</strong></p>
                        <p>Last Updated: <strong>{invoiceQuery?.updated}</strong></p>
                    </Col>
                    <Col span={12}>
                        <p>Reference: <strong>{invoiceQuery?.reference}</strong></p>
                        <p>Opened by: <strong>{invoiceQuery?.created_by}</strong></p>
                        <p>Date opened: <strong>{invoiceQuery?.created}</strong></p>
                    </Col>
                </Row>
                <p>Notes:</p>
                <div>
                    <p>{invoiceQuery?.notes}</p>
                </div>
                <h4>Comments</h4>
                {invoiceQuery?.resolution_offered && (
                    <p>
                        <button
                            type="submit"
                            className="btn btn-secondary btn-sm"
                            onClick={acceptResolution}>
                            Accept resolution
                        </button>
                    </p>
                )}
                <div className="comments-container">
                    {invoiceQueryComments.map(comment => (
                        <div className="comment-container">
                            {comment.content.includes('<em>') ? (
                                <div className="comment-content-container" style={{ fontStyle: 'italic', fontWeight: 600, color: '#d6336c' }}>
                                    {comment.content.replace('<em>', '').replace('</em>', '')}
                                </div>
                            ) : (
                                <div className="comment-content-container">
                                    {comment.content}
                                </div>
                            )}
                            <abbr>added on {comment.created} by {comment.author}</abbr>
                        </div>
                    ))}
                </div>
                {invoiceQuery?.comments_open && (
                    <div className="add-comment-container">
                        <Row>
                            <Col span={24}>
                                <Form form={form} layout="vertical" onFinish={submitComment}>
                                    <Form.Item
                                        name="comment"
                                        label={<div style={{ marginBottom: '10px' }}>Add a comment</div>}>
                                        <Input.TextArea
                                            placeholder="Add a comment.."
                                            style={{
                                                backgroundColor: '#eeeef0',
                                                minHeight: '100px',
                                            }} />
                                    </Form.Item>
                                    <Button type="primary" htmlType="submit">Submit</Button>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </Spin>
    );
};

export default InvoiceQuery;
